import { Link } from "react-router-dom";
import { PenSquare } from "lucide-react";
import { REVIEWS } from "../../data/reviews";
import { USE_CASES } from "../../data/useCases";
import { GUIDES } from "../../data/guides";
import { EmailOptInForm } from "../EmailOptInForm";
import { SITE } from "../../constants/testIds";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-surface/40 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid lg:grid-cols-[1.3fr_1fr_1fr_1fr] gap-10 pb-12 border-b border-white/10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-sm bg-primary flex items-center justify-center">
                <PenSquare className="w-4 h-4 text-white" aria-hidden="true" />
              </span>
              <span className="font-display font-bold text-white">AI Writing<span className="text-gradient-gold">Platforms</span></span>
            </Link>
            <p className="text-sm text-zinc-500 leading-relaxed max-w-xs mb-5">Hands-On AI Writing Tool Reviews for Professionals. We test every tool ourselves before we recommend it.</p>
            <p className="font-mono-tag text-xs uppercase tracking-wider text-zinc-500 mb-2">Get the Prompts Library</p>
            <EmailOptInForm source="footer" compact className="max-w-md" />
          </div>
          <div>
            <p className="font-mono-tag text-xs uppercase tracking-wider text-gold mb-4">Reviews</p>
            <ul className="space-y-2.5">
              {REVIEWS.map((r) => (
                <li key={r.slug}><Link to={`/reviews/${r.slug}`} className="text-sm text-zinc-400 hover:text-white transition-colors">{r.title.split(":")[0].replace(" Review 2026", "")}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono-tag text-xs uppercase tracking-wider text-gold mb-4">By Use Case</p>
            <ul className="space-y-2.5">
              {USE_CASES.slice(0, 6).map((u) => (
                <li key={u.slug}><Link to={`/use-cases/${u.slug}`} className="text-sm text-zinc-400 hover:text-white transition-colors">{u.title.replace("Best AI Tool for ", "").replace("Best AI Writing Tool for ", "")}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono-tag text-xs uppercase tracking-wider text-gold mb-4">Guides</p>
            <ul className="space-y-2.5">
              {GUIDES.slice(0, 6).map((g) => (
                <li key={g.slug}><Link to={`/guides/${g.slug}`} className="text-sm text-zinc-400 hover:text-white transition-colors line-clamp-1">{g.title}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pt-8">
          <p className="text-xs text-zinc-500">© 2026 aiwritingplatforms.com — All rights reserved. Contains affiliate links.</p>
          <div className="flex gap-6">
            <Link to="/affiliate-disclosure" data-testid={SITE.footerDisclosure} className="text-xs text-zinc-500 hover:text-white transition-colors">Affiliate Disclosure</Link>
            <Link to="/privacy-policy" data-testid={SITE.footerPrivacy} className="text-xs text-zinc-500 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/about" className="text-xs text-zinc-500 hover:text-white transition-colors">About</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
